import { ShipmentType } from "../../../models/enums/shipment-type";
import { OrderStatus } from "../../../models/ordering/enums/order-status"; 
import { ShipmentStatus } from "../../../transportation/models/enums/shipment-status";
import { PhysicalInventoryStatus } from './physical-inventory-enums';

export class PhysicalInventoryShipments {
    public truckCount: number = 0;
    public containerCount: number = 0;
    public reportStatus: PhysicalInventoryStatus = PhysicalInventoryStatus.inProgress
    public shipments: PhysicalInventoryShipmentInfo[] = [];
    public totalValue?: number = undefined;
}

export class PhysicalInventoryShipmentInfo {
    public id: number = 0;
    public serviceCenterId: string = "";
    public type: ShipmentType = ShipmentType.Truck;
    public status: ShipmentStatus = ShipmentStatus.Open;
    public name: string = '';

    public struts: IncludeType = IncludeType.none;
    public springs: IncludeType = IncludeType.none;
    public track: IncludeType = IncludeType.none;
    public hardware: IncludeType = IncludeType.none;
    public sections: IncludeType = IncludeType.none;
    public windows: IncludeType = IncludeType.none;

    // Indicates if the shipment is selected in the UI
    public isChecked: boolean = false;

    public orders: PhysicalInventoryShipmentOrderInfo[] = [];
}

export class PhysicalInventoryShipmentOrderInfo {
    public id: string = '';
    public lineNumber?: number= 0;
    public dealerName: string = '';
    public description: string = '';
    public jobName: string = '';
    public quantity: number = 0;
    public status: OrderStatus = OrderStatus.Pending;
    public value: number = 0;

    public struts: boolean = false;
    public springs: boolean = false;
    public track: boolean = false;
    public hardware: boolean = false;
    public sections: boolean = false;
    public windows: boolean = false;

    // Indicates if the order is selected in the UI
    public isChecked: boolean = false;
}

export enum IncludeType {
    none = 0,
    all = 1,
    partial = 2
}

export const IncludeTypeMetadata = {
    '0': { display: 'None', class: 'none', value: 0 },
    '1': { display: 'All', class: 'all', value: 1 },
    '2': { display: 'Partial', class: 'partial', value: 2 }
}